<template>
  <v-dialog v-model="show" :persistent="loading" @close="close" max-width="500">
    <v-card :loading="loading" rounded="lg">
      <div class="pa-4">
        <h5>Enviar solicitação</h5>
        <v-list>
          <v-list-item v-for="item in itemsList" :key="item.id">
            <v-list-item-avatar>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-avatar>
            <v-list-item-content class="py-1">
              <v-list-item-title class="font-weight-bold">
                {{ item.name }}
              </v-list-item-title>
              <v-list-item-subtitle class="text-body-2 font-weight-medium">
                {{ item.total | currency }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <v-divider class="" />

        <v-textarea
          v-model="message"
          label="Mensagem adicional"
          outlined
          rows="3"
          class="mt-4"
          hide-details
        />

        <my-bank-account-selector v-model="bankAccount" class="mt-4" />

        <v-alert type="warning" dense text class="mt-4">
          Atenção, não será possível alterar a solicitação após o envio.
        </v-alert>

        <v-alert v-if="error" type="error" class="mt-4 mb-0">
          {{ error }}
        </v-alert>
        <div class="d-flex align-center gap-2 mt-4">
          <v-btn text @click="close" :disabled="loading"> Cancelar </v-btn>
          <v-spacer />
          <v-btn
            color="primary"
            @click="submit"
            :disabled="loading || !bankAccount"
          >
            Enviar
          </v-btn>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import RESOURCE_REQUEST from "@/services/admin/resourceRequest";
import MyBankAccountSelector from "@/components/global/selector/MyBankAccountSelector.vue";

export default {
  name: "ResourceRequestSubmitModal",
  components: {
    MyBankAccountSelector,
  },
  props: {
    types: {
      type: Object,
      required: true,
    },
    itens: {
      type: Array | Boolean,
      required: true,
    },
    resourceRequest: {
      type: Object | null,
    },
  },
  data() {
    return {
      show: false,
      loading: false,
      error: null,
      bankAccount: null,
      message: "",
    };
  },
  methods: {
    open() {
      this.show = true;
    },
    close() {
      this.show = false;
    },
    async submit() {
      try {
        this.loading = true;
        this.error = null;
        await RESOURCE_REQUEST.submit(this.resourceRequest.id, {
          bankAccountId: this.bankAccount.id,
          message: this.message,
        });
        this.$emit("success");
        this.close();
      } catch (e) {
        this.error = e.message || "Erro ao enviar solicitação de recurso";
      } finally {
        this.loading = false;
      }
    },
  },
  computed: {
    ...mapGetters("auth", ["hasPermission"]),
    itemsList() {
      if (!this.itens) return [];
      const grouped = this.itens.reduce((acc, item) => {
        acc[item.type] = acc[item.type] || {
          ...this.types[item.type],
          total: 0,
        };

        acc[item.type].total += item.amount;
        return acc;
      }, {});
      return Object.values(grouped);
    },
  },
  mounted() {
    this.$parent.$on("submit-resource-request", this.open);
  },
};
</script>
